




































































import Vue from 'vue';
import Currency from '@/components/Currency.vue';
import Comprobante from '@/models/Comprobante';
import FormaCobro from '@/models/FormaCobro';
import Campo from '@/models/Campo';

import Entidad from '@/models/Entidad.vue';
export default {
	name: 'CuentaCorriente',
	inject: ['responsive'],
	components: {
		Currency,
	},
	data() {
		return {
			activeName: '1',
		};
	},
	watch: {},

	computed: {
		formasCobro() {
			return this.$store.state.recibos.formasCobro;
		},
		formularioCobro() {
			return this.$store.state.recibos.formularioCobro;
		},
		pendientesSelected() {
			return this.$store.state.recibos.pendientesSelected;
		},
		totalAcobrar() {
			return this.$store.state.recibos.totalAcobrar;
		},
		formObservaciones() {
			return this.$store.state.recibos.formObservaciones;
		},
		files() {
			return this.$store.state.recibos.files;
		},
	},
	filters: {},
	methods: {
		handleSelectionChange(selection) {
			alert('FLo');
		},
		handleCellClick(row) {
			this.$refs.table.toggleRowSelection(row);
		},
		getTitle(fdc) {
			if (fdc.metodo !== '') {
				var metodo = { descon: '' };
				var detalle = '';
				if (fdc) {
					metodo = this.formasCobro.find((x: FormaCobro) => x.codcon === fdc.metodo);
					fdc.campos.forEach((campo: Campo) => {
						if (campo.suma) detalle = `${campo.value}`;
					});
				}

				return metodo.descon + ': ' + detalle;
			}
		},
	},
	mounted() {
		//this.$store.dispatch('callTableRecibos');
	},
};
